// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: inherit;
  height: inherit;
  display: inline-block;
}

.toggle-icon {
  width: inherit;
  margin: 0px !important;
  padding: 0px !important;
}

label {
  min-width: inherit;
  min-height: inherit;
  list-style: none;
  display: inline-flex;
  cursor: pointer;
}

.toggle-icon > label:nth-child(2) {
  display: none;
}

.toggle-icon.is-active > label:nth-child(1) {
  display: none;
}

.toggle-icon.is-active > label:nth-child(2) {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/core/toggle-icon/toggle-icon.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,eAAA;EACA,qBAAA;AACJ;;AAGA;EACI,cAAA;EACA,sBAAA;EACA,uBAAA;AAAJ;;AAEA;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AACA;EACI,cAAA;AAEJ","sourcesContent":[":host{\n    width:inherit;\n    height:inherit;\n    display:inline-block\n}\n\n \n.toggle-icon{\n    width:inherit;\n    margin:0px !important;\n    padding:0px !important;\n}\nlabel{\n    min-width:inherit;\n    min-height:inherit;\n    list-style: none;\n    display: inline-flex;\n    cursor: pointer;\n}\n\n.toggle-icon > label:nth-child(2){\n    display: none;\n}\n\n.toggle-icon.is-active > label:nth-child(1){\n    display: none;\n}\n.toggle-icon.is-active > label:nth-child(2){\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
